import * as React from "react";
import { User } from "types";

const dummyUser: User = {
  active: true,
  credentials: [],
  department: "Physician Department",
  email: "pepe@medstone.tech",
  firstName: "Pepe",
  middleName: "Pepe",
  lastName: "Admin",
  id: "1",
  phoneNumber: "123456789",
  staffId: "2",
};

const AuthContext = React.createContext<User>(dummyUser);

type StoryboardAuthProps = {
  children?: React.ReactNode;
};

const StoryboardAuth = (props: StoryboardAuthProps) => {
  const { children } = props;
  return (
    <AuthContext.Provider value={dummyUser}>{children}</AuthContext.Provider>
  );
};

export { StoryboardAuth };
